import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './Navbar.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Book' },
  { to: '/about', label: 'About' },
  { to: '/drive', label: 'Drive with us' },
  { to: '/support', label: 'Support' },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  return (
    <header className="header">
      <div className="header__content">
        <Link to="/" className="header__logo-link">
          <Logo />
        </Link>

        <nav className={`header__nav ${mobileMenuOpen ? 'header__nav--open' : ''}`}>
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`header__nav-link ${location.pathname === link.to ? 'header__nav-link--active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="header__actions">
          <a href="tel:1800XXXXXXX" className="header__phone">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <span>1800-XXX-XXXX</span>
          </a>
          <Link to="/estimate" className="header__cta-btn">
            Book a ride
          </Link>
        </div>

        <button
          className="header__hamburger"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span className={`header__hamburger-line ${mobileMenuOpen ? 'header__hamburger-line--open' : ''}`} />
          <span className={`header__hamburger-line ${mobileMenuOpen ? 'header__hamburger-line--open' : ''}`} />
          <span className={`header__hamburger-line ${mobileMenuOpen ? 'header__hamburger-line--open' : ''}`} />
        </button>
      </div>
    </header>
  );
};

export default Header;
export { Header as Navbar };
